import React from 'react';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
import { useDeckVotes } from '../../hooks/useDeckVotes';
import { useAuth } from '../../hooks/useAuth';
import { useTranslation } from '../../hooks/useTranslation';

interface DeckVotesProps {
  deckId: string;
}

export function DeckVotes({ deckId }: DeckVotesProps) {
  const { votes, vote } = useDeckVotes(deckId);
  const { user } = useAuth();
  const { t } = useTranslation();

  const handleVote = (isUpvote: boolean) => {
    if (!user) {
      alert(t('deck_votes.login_required'));
      return;
    }
    vote(isUpvote);
  };

  return (
    <div className="flex flex-col items-center gap-3">
      {!user ? (
        <p className="text-sm text-gray-500 text-center">
          {t('deck_votes.login_to_vote')}
        </p>
      ) : (
        <p className="text-sm text-gray-500 text-center">
          {votes.userVote === null ? t('deck_votes.what_do_you_think') : t('deck_votes.your_vote')}
        </p>
      )}
      <div className="flex gap-3">
        <button
          onClick={() => handleVote(true)}
          disabled={!user}
          className={`flex flex-col items-center gap-1.5 px-4 py-2 rounded-lg transition-all ${
            votes.userVote === true
              ? 'bg-green-100 text-green-700 ring-2 ring-green-600'
              : 'hover:bg-gray-100 text-gray-600'
          } ${!user && 'opacity-50 cursor-not-allowed'}`}
        >
          <ThumbsUp className={`w-6 h-6 ${votes.userVote === true ? 'fill-green-700' : ''}`} />
          <span className="text-xs font-medium">{t('deck_votes.like')}</span>
        </button>
        
        <button
          onClick={() => handleVote(false)}
          disabled={!user}
          className={`flex flex-col items-center gap-1.5 px-4 py-2 rounded-lg transition-all ${
            votes.userVote === false
              ? 'bg-red-100 text-red-700 ring-2 ring-red-600'
              : 'hover:bg-gray-100 text-gray-600'
          } ${!user && 'opacity-50 cursor-not-allowed'}`}
        >
          <ThumbsDown className={`w-6 h-6 ${votes.userVote === false ? 'fill-red-700' : ''}`} />
          <span className="text-xs font-medium">{t('deck_votes.dislike')}</span>
        </button>
      </div>
    </div>
  );
}